var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E74C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3867 6.00001C14.0902 6.00307 15.6368 6.67435 16.7787 7.7656L17.6968 6.84752C18.0855 6.45888 18.75 6.73414 18.75 7.28377V10.7298C18.75 11.0706 18.4738 11.3468 18.1331 11.3468H14.687C14.1374 11.3468 13.8621 10.6823 14.2507 10.2936L15.324 9.22039C14.5306 8.47752 13.504 8.06602 12.4133 8.05661C10.0382 8.0361 8.03607 9.95824 8.05661 12.4122C8.07609 14.7402 9.9634 16.6936 12.375 16.6936C13.4322 16.6936 14.4314 16.3162 15.2188 15.6253C15.3407 15.5184 15.5248 15.5249 15.6395 15.6395L16.6591 16.6591C16.7843 16.7843 16.7781 16.9885 16.6467 17.1072C15.5163 18.1283 14.0183 18.75 12.375 18.75C8.8542 18.75 6.00003 15.8958 6 12.3751C5.99997 8.8583 8.86993 5.99371 12.3867 6.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.59dd17af320afe36d0bc4e1147ec1bf0.svg";
export { ForwardRef as ReactComponent };